import React from 'react';
import SOPList from '../../components/sop/SOPList';

const SOPDashboard: React.FC = () => {
  return <SOPList />;
};

export default SOPDashboard;